export default {
  portalUrl:
    process.env.VUE_APP_PORTAL_URL ||
    "https://app.flixcheck.com/portal/dashboard",
  landingPageUrl:
    process.env.VUE_APP_LANDING_PAGE_URL || "https://flixcheck.com/",
  chatScriptUrl: process.env.VUE_APP_CHAT_SCRIPT_URL || "",
  profileStorageKey: "flixcheckShop.profile",
}
